export default __webpack_public_path__ + "static/anb-logo-8170851ee694f86fa845f63120091d87.png";